import { ZoneDeviceDetailsService } from './../zone-device-details.service';
import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { DialogComponent as SyncfusionDialogComponent } from '@syncfusion/ej2-angular-popups';
import { ZoneDeviceBrand, ZoneDeviceDTO, ZoneDeviceType } from 'src/app/base/models/models.swagger.generated';
import { EnumTranslationService } from 'src/app/base/services/enum-translation.service';
import { DropDownConstantsFactory } from 'src/app/base/shared/syncfusion/dropdown-constants-factory';
import { TranslateModule } from '@ngx-translate/core';
import { AppErrorMessagesComponent } from '../../../../../../base/error-messages/app-error-messages.component';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { DialogModule } from '@syncfusion/ej2-angular-popups';

export type AddInitialDeviceFormType = {
  deviceType: FormControl<ZoneDeviceType>;
  brand: FormControl<ZoneDeviceBrand>;
};

@Component({
    selector: 'app-zone-device-add',
    templateUrl: './zone-device-add.component.html',
    styleUrls: ['./zone-device-add.component.scss'],
    imports: [DialogModule, ReactiveFormsModule, DropDownListModule, AppErrorMessagesComponent, TranslateModule]
})
export class ZoneDeviceAddComponent implements OnInit {
  @ViewChild('addDialog') public addDialog: SyncfusionDialogComponent;
  @Output() public deviceStructureCreated = new EventEmitter<ZoneDeviceDTO>();
  @Output() public cancelled = new EventEmitter();

  public deviceTypes: any[] = null;
  public deviceBrands = [];
  public enumDropdownSettings = DropDownConstantsFactory.createNumericEnumDropdownSettings();

  public addForm = this.fb.group<AddInitialDeviceFormType>({
    deviceType: this.fb.control<ZoneDeviceType>(null, Validators.required),
    brand: this.fb.control<ZoneDeviceBrand>(null, Validators.required),
  });

  private allDeviceTypes = this.enumTranslateService.translateNumericEnum(ZoneDeviceType, 'i18n.shared.zone-device-enums.device-type.');
  private allDeviceBrands = this.enumTranslateService.translateNumericEnum(ZoneDeviceBrand, 'i18n.shared.zone-device-enums.brand.');
  private allSpecs = [];

  constructor(private fb: FormBuilder, private zoneDeviceDetailsService: ZoneDeviceDetailsService, private enumTranslateService: EnumTranslationService,) { }

  ngOnInit() {
    this.zoneDeviceDetailsService.loadAvailableDeviceSpecifications().subscribe(specs => {
      this.allSpecs = specs;
      this.deviceBrands = this.allDeviceBrands.filter(brand => this.allSpecs.some(spec => spec.brand === brand.value as any));
    });
    this.addForm.controls.brand.valueChanges.subscribe(brand => {
      const specsOfBrand = this.allSpecs.filter(spec => spec.brand === brand);
      this.deviceTypes = this.allDeviceTypes
        .filter(type => specsOfBrand.some(ab => ab.deviceType === type.value as any));
    })
  }

  public openAdd(): void {
    setTimeout(() => {
      this.addDialog.show();
    },0);
  }

  public isAddOpened(): boolean {
    return this.addDialog && this.addDialog.visible;
  }

  public closeAdd(): void {
    this.cancelled.emit();
    this.closed();
  }

  // close event is triggered on dialog close and not only be close icon -> i.e. rather on this.addDialog.hide()
  public onDialogClose($event: any): void {
    if ($event.closedBy == 'close icon') {
      this.cancelled.emit();
    }
  }

  public closed(): void {
    this.addDialog.hide();
    this.addForm.reset();
  }

  public initializeDevice(): void {
    const formValues = this.addForm.value;

    this.zoneDeviceDetailsService.getZoneDeviceInitialStructure(formValues.deviceType, formValues.brand)
      .subscribe(newDevice => {
        this.addDialog.hide();
        this.addForm.reset();
        this.deviceStructureCreated.emit(newDevice);
      });
  }

}
